import { CapoPlugin } from "/codebuild/output/src3418197868/src/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];